import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthCallback: React.FC = () => {
    const navigate = useNavigate(); 
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams.toString());
    const accessToken = urlParams.get('access_token') as string;
    const access_token_expiry = urlParams.get('token_expiry') as string;
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('token_expiry', access_token_expiry);
    localStorage.removeItem('lookupData');

    useEffect(() => {
      if (!localStorage.getItem('access_token')) {
      
      const urlParams = new URLSearchParams(window.location.search);
      console.log(urlParams.toString());
  
      const accessToken = urlParams.get('access_token');
      const access_token_expiry = urlParams.get('token_expiry');
      const redirect_url = urlParams.get('redirect_url');
  
    if (!accessToken || !access_token_expiry || !redirect_url) {
      console.error("Missing necessary parameters in the URL");
      navigate('/login');
      return;
    }
    localStorage.setItem('access_token', accessToken);

    if (!isNaN(Number(access_token_expiry))) {
      localStorage.setItem('token_expiry', access_token_expiry);
    } else {
      console.error("Invalid token expiry in URL:", access_token_expiry);
      navigate('/login'); 
      return;
    }
  }
 
    navigate('/dashboard');
  
    }, [navigate]);

  return <div>Redirecting...</div>;
};

export default AuthCallback;
